import SeequreLogo from "assets/divisions/icons/seequre-logo.svg";
import AdhereLogo from "assets/divisions/icons/adhere-logo.svg";
import OculusLogo from "assets/divisions/icons/oculus-logo.svg";
import AcademyLogo from "assets/divisions/icons/academy-logo.svg";

import SeequreImage from "assets/divisions/images/seequre-image.png";
import AdhereImage from "assets/divisions/images/adhere-image.png";
import OculusImage from "assets/divisions/images/oculus-image.png";
import AcademyImage from "assets/divisions/images/academy-image.png";

import ShoppingBag from "assets/industries/Shopping bag.svg";
import DollarSignBag from "assets/industries/dollar-circle.svg";
import CisoSecurity from "assets/industries/ciso-and-security.svg";
import LegalBag from "assets/industries/legal.svg";

export const exploreDivisionsEn = [
  {
    logo: SeequreLogo,
    title: "End-to-end cybersecurity and compliance.",
    description:
      "Meet global standards with AI-driven risk assessment, security tools, and privacy frameworks.",
    features: [
      {
        title: "Risk Management",
        description:
          "Simplify annual risk assessment for your business with automated risk register.",
      },
      {
        title: "Vulnerability Scanner",
        description: "Verify open ports and active services on your servers.",
      },
      {
        title: "SmartGuard",
        description:
          "An application that helps protect desktop/laptop from cyber attack.",
      },
      {
        title: "Penetration Testing",
        description:
          "With qualified testers, run penetration test quickly and with ease.",
      },
    ],
    image: SeequreImage,
    link: "https://secure.smartcomply.com/",
  },
  {
    logo: AdhereLogo,
    title: "Stay compliant. Stop risk early.",
    description:
      "Monitor activity in real time, detect threats fast, and protect your business without slowing operations.",
    features: [
      {
        title: "Transaction Monitoring",
        description:
          "Monitor every transaction as it happens and stay compliant.",
      },
      {
        title: "Identity Verification",
        description:
          "Authenticate identities with advance technology in real time.",
      },
      {
        title: "Loan Application Fraud Check",
        description: "Analyze key financial factors before approving loan.",
      },
      {
        title: "Sanction Check",
        description:
          " Identify potential risks associated with engaging in transactions",
      },
    ],
    image: AdhereImage,
    link: "https://adhere.smartcomply.com/",
  },
  {
    logo: OculusLogo,
    title: "Stay ahead of emerging Cyber threats",
    description:
      "Oculus delivers proactive threat intelligence beyond your perimeter to prevent attacks early.",
    features: [
      {
        title: "Brand & Domain Protection",
        description:
          "We monitor dark web channels to detect brand threats early.",
      },
      {
        title: "Data Leakage Detection",
        description:
          "We monitor dark web channels to detect brand threats early.",
      },
      {
        title: "Takedown Services",
        description:
          "We monitor dark web channels to detect brand threats early.",
      },
      {
        title: "Dark Web Monitoring",
        description:
          "We monitor dark web channels to detect brand threats early.",
      },
    ],
    image: OculusImage,
    link: "https://oculusintel.xyz/",
  },
  {
    logo: AcademyLogo,
    title: "Become a Certified Cybersecurity Professional",
    description:
      "Access expert-led training on compliance, cybersecurity, and risk management.",
    features: [
      {
        title: "Certified ISO/IEC 22301 Lead Auditor",
      },
      {
        title: "Certified ISO/IEC 27001 Lead Auditor",
      },
      {
        title: "ISO 27701 & Data Protection Officer (DPO) Certification",
      },
      {
        title: "Secure Coding Training: professional level",
      },
    ],
    image: AcademyImage,
    link: "https://academy.smartcomply.com/",
  },
];

export const exploreDivisionsFr = [
  {
    logo: SeequreLogo,
    title: "Cybersécurité et conformité de bout en bout.",
    description:
      "Respectez les normes internationales grâce à l’évaluation des risques basée sur l’IA, aux outils de sécurité et aux cadres de protection de la vie privée.",
    features: [
      {
        title: "Gestion des Risques",
        description:
          "Simplifiez l’évaluation annuelle des risques de votre entreprise grâce à un registre des risques automatisé.",
      },
      {
        title: "Scanner de Vulnérabilités",
        description:
          "Vérifiez les ports ouverts et les services actifs sur vos serveurs.",
      },
      {
        title: "SmartGuard",
        description:
          "Une application qui aide à protéger les ordinateurs contre les cyberattaques.",
      },
      {
        title: "Tests d’Intrusion",
        description:
          "Avec des testeurs qualifiés, réalisez rapidement et facilement des tests d’intrusion.",
      },
    ],
    image: SeequreImage,
    link: "https://secure.smartcomply.com/",
  },
  {
    logo: AdhereLogo,
    title: "Restez conforme. Stoppez les risques dès le départ.",
    description:
      "Surveillez les activités en temps réel, détectez rapidement les menaces et protégez votre entreprise sans ralentir vos opérations.",
    features: [
      {
        title: "Surveillance des Transactions",
        description:
          "Surveillez chaque transaction en temps réel et restez conforme.",
      },
      {
        title: "Vérification d’Identité",
        description:
          "Authentifiez les identités grâce à une technologie avancée en temps réel.",
      },
      {
        title: "Contrôle de Fraude des Demandes de Prêt",
        description:
          "Analysez les principaux facteurs financiers avant d’approuver un prêt.",
      },
      {
        title: "Vérification des Sanctions",
        description: "Identifiez les risques potentiels liés aux transactions.",
      },
    ],
    image: AdhereImage,
    link: "https://adhere.smartcomply.com/",
  },
  {
    logo: OculusLogo,
    title: "Gardez une longueur d’avance sur les cybermenaces émergentes",
    description:
      "Oculus fournit une intelligence proactive sur les menaces au-delà de votre périmètre afin de prévenir les attaques à un stade précoce.",
    features: [
      {
        title: "Protection de la Marque et des Domaines",
        description:
          "Nous surveillons les canaux du dark web pour détecter les menaces liées à la marque dès le début.",
      },
      {
        title: "Détection des Fuites de Données",
        description:
          "Nous surveillons les canaux du dark web pour détecter les menaces liées à la marque dès le début.",
      },
      {
        title: "Services de Suppression (Takedown)",
        description:
          "Nous surveillons les canaux du dark web pour détecter les menaces liées à la marque dès le début.",
      },
      {
        title: "Surveillance du Dark Web",
        description:
          "Nous surveillons les canaux du dark web pour détecter les menaces liées à la marque dès le début.",
      },
    ],
    image: OculusImage,
    link: "https://oculusintel.xyz/",
  },
  {
    logo: AcademyLogo,
    title: "Devenez un Professionnel Certifié en Cybersécurité",
    description:
      "Accédez à des formations animées par des experts en conformité, cybersécurité et gestion des risques.",
    features: [
      {
        title: "Auditeur Principal Certifié ISO/IEC 22301",
      },
      {
        title: "Auditeur Principal Certifié ISO/IEC 27001",
      },
      {
        title:
          "Certification ISO 27701 & Délégué à la Protection des Données (DPO)",
      },
      {
        title: "Formation en Codage Sécurisé : niveau professionnel",
      },
    ],
    image: AcademyImage,
    link: "https://academy.smartcomply.com/",
  },
];

export const industriesEn = [
  {
    icon: ShoppingBag,
    title: "Marketplace",
    description:
      "Monitor transactions, detect fraud early, and secure customer data across high-volume digital payments.",
  },
  {
    icon: DollarSignBag,
    title: "Financial Institution",
    description:
      "They use Smartcomply to prevent fraud, meet AML requirements, and verify customers at scale without slowing transactions.",
  },
  {
    icon: CisoSecurity,
    title: "CISO & Security Team",
    description:
      "Gain centralized visibility into security posture, risk exposure, and compliance status across the organization.",
  },
  {
    icon: LegalBag,
    title: "Executive & Legal",
    description:
      "Stay ahead of regulatory requirements, reduce compliance risk, and support audits with accurate, real-time data.",
  },
  {
    icon: ShoppingBag,
    title: "Telecommunications",
    description:
      "Safeguard customer data, monitor large-scale transactions, and prevent cyber threats across networks and digital services.",
  },
  {
    icon: DollarSignBag,
    title: "Insurance",
    description:
      "Strengthen risk assessment, detect fraudulent claims, and ensure regulatory compliance across underwriting and claims processing.",
  },
];
export const industriesFr = [
  {
    icon: ShoppingBag,
    title: "Marketplace",
    description:
      "Surveillez les transactions, détectez la fraude rapidement et sécurisez les données clients dans les paiements numériques à volume élevé.",
  },
  {
    icon: DollarSignBag,
    title: "Institution Financière",
    description:
      "Elles utilisent Smartcomply pour prévenir la fraude, respecter les exigences LBC/FT et vérifier les clients à grande échelle sans ralentir les transactions.",
  },
  {
    icon: CisoSecurity,
    title: "CISO & Équipe de Sécurité",
    description:
      "Obtenez une visibilité centralisée sur la posture de sécurité, l’exposition aux risques et l’état de conformité de l’organisation.",
  },
  {
    icon: LegalBag,
    title: "Direction & Juridique",
    description:
      "Anticipez les exigences réglementaires, réduisez les risques de conformité et facilitez les audits grâce à des données précises et en temps réel.",
  },
  {
    icon: ShoppingBag,
    title: "Télécommunications",
    description:
      "Protégez les données clients, surveillez les transactions à grande échelle et prévenez les cybermenaces sur les réseaux et services numériques.",
  },
  {
    icon: DollarSignBag,
    title: "Assurance",
    description:
      "Renforcez l’évaluation des risques, détectez les réclamations frauduleuses et assurez la conformité réglementaire dans le traitement des souscriptions et des sinistres.",
  },
];

export const statsEn = [
  {
    label: "API calls for loan applicant verification",
    value: 400000,
    suffix: "+",
  },
  { label: "Total transactions monitored", value: 10000000, suffix: "+" },
  { label: "Smartguard app installations", value: 8000, suffix: "+" },
  { label: "Dark web data-leakage checks", value: 1000, suffix: "+" },
];

export const statsFr = [
  {
    label: "Appels API pour la vérification des demandeurs de prêt",
    value: 400000,
    suffix: "+",
  },
  {
    label: "Transactions totales surveillées",
    value: 10000000,
    suffix: "+",
  },
  {
    label: "Installations de l’application Smartguard",
    value: 8000,
    suffix: "+",
  },
  {
    label: "Contrôles de fuites de données sur le dark web",
    value: 1000,
    suffix: "+",
  },
];
